import React, { FC, ReactElement } from 'react'
import styled from 'styled-components'
interface Props {
  url: string
}
const Link: FC<Props> = ({ url }): ReactElement => {
  return (
    <StyledLink
      className='App-link'
      href={url}
      target='_blank'
      rel='noopener noreferrer'
    >
      Learn React
    </StyledLink>
  )
}
const StyledLink = styled.a`
  color: var(--petrol-bright-3);
`

export default Link
